/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { returnCheckboxAndRadioStyle } from "./field-style-util";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../colors";

type Props = {
  label?: string;
  innerRef?: any;
  text?: React.ReactNode;
  wrapperWidth?: string;
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

export const CheckboxField = ({
  label,
  value,
  innerRef,
  disabled,
  text,
  wrapperWidth,
  ...rest
}: Props) => {
  const textStyle = css`
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.35);
  `;
  const iconStyle = css`
    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.5));
  `;

  return (
    <label css={returnCheckboxAndRadioStyle("4px", wrapperWidth)}>
      <input
        disabled={disabled}
        value={value}
        type="checkbox"
        ref={innerRef}
        {...rest}
      />
      <span className="customElement">
        <div className="checkedIndicator">
          <StyledText className="bodyTextRegular mb-0" css={textStyle}>
            {text ? (
              text
            ) : (
              <FontAwesomeIcon css={iconStyle} icon={solid("check")} />
            )}
          </StyledText>
        </div>
      </span>
      {label && (
        <StyledText
          color={disabled ? colors.textSecondary : colors.textPrimary}
          className="bodyTextRegular mb-0"
        >
          {label}
        </StyledText>
      )}
    </label>
  );
};
